import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
    baseURL: siteConfig.siteUrl.API_URL
}

const authHeaders = () => ({
    Authorization: localStorage.getItem('access_token'),
    AuthId: localStorage.getItem('id_token')
});

export function* getTickets(action) {
    const query = action.query ? `?${action.query}` : '';
    const res = yield gaxios.request({
        url: 'api/tickets' + query,
        headers: authHeaders(),
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({
            type: actions.GET_TICKETS_SUCCESS,
            payload: { tickets: res.data.tickets, paginationInfo: res.data.paginationInfo },
        });
    }
}

export function* getTicketDetail(action) {
    const res = yield gaxios.request({
        url: 'api/tickets/' + action.id,
        headers: authHeaders(),
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({
            type: actions.GET_TICKET_DETAIL_SUCCESS,
            payload: res.data.ticket,
        });
    }
}

export function* createTicket(action) {
    const res = yield gaxios.request({
        url: 'api/tickets',
        method: 'POST',
        data: action.data,
        headers: authHeaders(),
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', `Ticket ${res.data.ticket.codigo} creado`);
        if (action.history) {
            action.history.push('/dashboard/soporte');
        }
    }
}

export function* cambiarEstadoTicket(action) {
    const res = yield gaxios.request({
        url: `api/tickets/${action.id}/estado`,
        method: 'PATCH',
        data: action.data,
        headers: authHeaders(),
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', 'Ticket actualizado');
        yield put({ type: actions.GET_TICKET_DETAIL_REQUEST, id: action.id });
    }
}

export function* comentarTicket(action) {
    const res = yield gaxios.request({
        url: `api/tickets/${action.id}/comentarios`,
        method: 'POST',
        data: action.data,
        headers: authHeaders(),
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({ type: actions.GET_TICKET_DETAIL_REQUEST, id: action.id });
    }
}

export default function* rootSaga() {
    yield all([
        yield takeEvery(actions.GET_TICKETS_REQUEST, getTickets),
        yield takeEvery(actions.GET_TICKET_DETAIL_REQUEST, getTicketDetail),
        yield takeEvery(actions.CREATE_TICKET_REQUEST, createTicket),
        yield takeEvery(actions.CAMBIAR_ESTADO_TICKET_REQUEST, cambiarEstadoTicket),
        yield takeEvery(actions.COMENTAR_TICKET_REQUEST, comentarTicket),
    ]);
}
